import React from "react";
import { FieldProps } from "@rjsf/utils";
import { NumberInput } from "../../../../../../Submissions/Fields";
import BaseFieldPreview from "./BaseFieldPreview";

const NumberFieldPreview = (props: FieldProps) => {
  const widgetPreview = <NumberInput {...props} />;

  return (
    <BaseFieldPreview
      widgetPreview={widgetPreview}
      {...props}
    ></BaseFieldPreview>
  );
};

export default NumberFieldPreview;
